/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__, or convert again using --optional-chaining
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Facebook convenience wrapper

namespace('Slzr', function(exports, top) {
  let jQuery;
  const $ = (jQuery = Slzr.jQuery);

  exports.Facebook = class Facebook {
    static streamPublish(data) {
      data.method = 'feed';
      return FB.getLoginStatus(function(response) {
        if (response.authResponse) { return FB.ui(data); }
      });
    }

    // Perform a facebook login, with the options specified.
    //
    // Options:
    //   scope: array of extended scopes to request (default: [email])
    static login(options_or_callback, callback) {
      let options;
      if (typeof(options_or_callback) === 'function') {
        callback = options_or_callback;
        options = {};
      } else {
        options = options_or_callback;
      }
        
      // Defaults
      options = $.extend({}, {scope: ['public_profile', 'email']}, options);

      // Require email permission, always
      if ($.inArray('email', options.scope) === -1) { options.scope.push('email'); }

      return FB.login(function(response) {
        if (response.authResponse) { hideIbox(); }
        return (typeof callback === 'function' ? callback(response) : undefined);
      },
       {scope: options.scope.join(',')});
    }

    // Log in without any extended permissions
    static oldLogin(callback) {
      return FB.login(function(response) {
        __guardMethod__(console, 'log', o => o.log("logged in without permissions:", response));
        return (typeof callback === 'function' ? callback(response) : undefined);
      });
    }

    // Revoke authorization
    static revoke(callback) {
      return FB.api('/me/permissions', 'delete', function(response) {
        __guardMethod__(console, 'log', o => o.log('revoked authorization', response));
        return (typeof callback === 'function' ? callback(response) : undefined);
      });
    }

    // Normalize permissions between graph v1 and v2
    //
    // Expects the response object from the API call to /me/permissions
    static normalizePermissions(response) {
      if (response.data[0].installed != null) {
        // API 1
        return (() => {
          const result = [];
          for (const permission in response.data[0]) {
            const value = response.data[0][permission];
            result.push(permission);
          }
          return result;
        })();
      } 
        // API 2
        return Array.from(response.data).map((item) => item.permission);
      
    }
  };

  top.postFBFeedItem = exports.Facebook.streamPublish;

  // Export the global variable assigned to `top` when built with webpack
  if ((typeof module !== 'undefined' && module !== null ? module.exports : undefined) != null) {
    return module.exports.postFBFeedItem = top.postFBFeedItem;
  }
});

//  $(document).onAction 'facebook-login', (evt) ->
//    previous_url = $(this).data('previous-url')
//
//    Slzr.Facebook.login (response) ->
//      if response.authResponse
//        window._lightbox_fb_login = true
//        location.href = "/auth/with/facebook/callback?origin=#{escape previous_url}"
//
//  $(document).onAction 'facebook-logout', (event) ->
//    FB.logout ->
//      location.href = "/auth/logout"

function __guardMethod__(obj, methodName, transform) {
  if (typeof obj !== 'undefined' && obj !== null && typeof obj[methodName] === 'function') {
    return transform(obj, methodName);
  } 
    return undefined;
  
}